export default class Sounder {

    constructor() {
        this.s = [];
        // this.add('fire', ['fire1', 'fire2', 'fire3'], 500);
        // this.add('fire2', ['fire4', 'fire5', 'fire6', 'fire7', 'fire8'], 200);
        // this.add('damage', ['damage1', 'damage2'], 250);
        // this.add('brick', ['brick1', 'brick2', 'brick3'], 250);
        this.add('alien-1');
        this.add('alien-2');
        this.add('alien-3');
        this.add('alien-4');
        this.add('boom-1');
        this.add('pop-1');
        this.add('put-2');
        this.add('pick-3');
        this.add('drop-1');
        this.add('drop-2');
        this.add('flame-2');
        this.add('flame-4');
        // this.add('win');
        // this.add('loose');
        // this.add('grow', ['grow1'], 1000);
        // this.add('splash', [1, 2, 3, 4, 5, 6].map(n => `splash${n}`), 100);
    }

    destroy() {
        this.s.forEach(s => s.destroy());
    }

    add(group, sounds = [group], cooldown = 500) {
        this[group] = {
            sounds: sounds.map(name => this.addSound(name, group)),
            cooldown: cooldown,
            canPlay: true
        }
    }

    addSound(name, group) {
        let s = game.add.sound(name);
        s.onPlay.add(() => {
            this[group].canPlay = false;
            game.time.events.add(this[group].cooldown, () => { this[group].canPlay = true; });
        });
        this.s.push(s);
        return s;
    }

    play(group) {
        if (this[group].canPlay) {
            game.rnd.pick(this[group].sounds).play();
        }
    }
}


// WEBPACK FOOTER //
// ./src/states/sounder.js